import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { GenericSvg } from "../../../assets/svgs/GenericSVG";
import { MainButton } from "../../../core/components/buttons/MainButton";
import { InfoText } from "../../../core/components/texts/InfoText";
import { useStyles } from "../../../core/styles/theme";
import { LoadingScreen } from "../../navigation/LoadingScreen";

type Props = {
  type: "404" | "Error";
};
export const ErrorOverlay = (props: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useStyles();
  const [showError, setShowError] = useState(false);

  const isError = props.type === "Error";

  const handleAction = () => {
    if (isError) {
      navigate(-1);
    } else {
      navigate(`/welcome`, { replace: true });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowError(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!showError) {
    return <LoadingScreen />;
  }

  return (
    <OuterContainer>
      <Container>
        <GenericSvg
          name="FailureIcon"
          primaryColor={theme.colors.primary}
          size={50}
        />
        <InfoText
          headline={
            isError ? t("ERROR_SOMETHING_WRONG") : t("ERROR_PAGE_NOT_FOUND")
          }
          text={[
            isError
              ? t("ERROR_LOADING_DESCRIPTION")
              : t("ERROR_NOT_FOUND_DESCRIPTION"),
          ]}
        />
        <MainButton
          text={isError ? t("ERROR_RELOAD_PAGE") : t("ERROR_BACK_TO_HOME")}
          onClick={handleAction}
        />
      </Container>
    </OuterContainer>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  max-width: 640px;
  gap: 20px;
  padding: 20px;
`;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
